/**
 * 查找字符串中所有空格的位置
 *
 * @param str 待查找的字符串
 * @returns 返回包含所有空格位置的数组
 */
var findAllWhitespaceIndexes = function findAllWhitespaceIndexes(str) {
  // 定义一个空数组，用于存放空格的位置
  var whitespaceIndexes = []; // 遍历字符串

  for (var i = 0; i < str.length; i++) {
    // 如果字符串中的字符是空格，则将空格的位置添加到数组中
    if (/\s/.test(str[i])) {
      whitespaceIndexes.push(i);
    }
  } // 返回空格的位置数组

  return whitespaceIndexes;
};
/**
 * 查找数组中与给定值 x 最接近的元素
 *
 * @param arr 待查找的数组
 * @param x 给定值
 * @returns 返回最接近 x 的元素，如果找不到则返回 undefined
 */

var findClosestValue = function findClosestValue(arr, x) {
  // let low = 0;
  // let high = arr.length - 1;
  // 如果数组为空，直接返回 undefined
  if (!(arr !== null && arr !== void 0 && arr.length) || typeof x !== 'number') {
    return undefined;
  }
  var minVal = arr[0]; // cr 之后换成遍历 因为首先数据不高 担心二分查找会死循环

  for (var i = 1, len = arr.length; i < len; i++) {
    var item = arr[i];
    if (Math.abs(item - x) < Math.abs(minVal - x)) {
      minVal = item;
    }
  }
  return minVal; // 二分查找
  // while (low <= high) {
  //   const mid = Math.floor((low + high) / 2);
  //   if (arr[mid] === x) {
  //     // 如果找到了精确匹配的值，直接返回
  //     return arr[mid];
  //   } else if (arr[mid] < x) {
  //     low = mid + 1;
  //   } else {
  //     high = mid - 1;
  //   }
  // }
  // 在二分查找结束后，low 和 high 会相邻
  // 返回最接近 x 的值
  // if (high < 0) {
  //   return arr[low];
  // } else if (low >= arr.length) {
  //   return arr[high];
  // } else {
  //   // 比较 low 和 high 两个值距离 x 的距离
  //   return Math.abs(arr[low] - x) < Math.abs(arr[high] - x) ? arr[low] : arr[high];
  // }
};
/**
 * 将字符串中的特定位置的空格替换为换行符
 *
 * @param str 待处理的字符串
 * @returns 返回替换后的字符串
 */

export var replaceSpaceWithNewline = function replaceSpaceWithNewline(str) {
  if (!str) {
    return str;
  }
  var whitespaceIndexes = findAllWhitespaceIndexes(str);
  if (!(whitespaceIndexes !== null && whitespaceIndexes !== void 0 && whitespaceIndexes.length)) {
    return str;
  }
  var idx = findClosestValue(whitespaceIndexes, (str === null || str === void 0 ? void 0 : str.length) / 2);
  return str.slice(0, idx) + '\n' + str.slice(Number(idx) + 1);
};